import React from 'react'
import styled from 'styled-components'
import {WINDOW_MODE_MOBILE_WIDTH} from 'consts'
import {getContentURL, getCurrencyValue} from 'utils'
import {Paragraph, Image, Icon} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftShopTemplateContentVideoBadge} from '../../../../gift-shop'
import {TransactionDetailContentItemSingleCreatorProps} from './TransactionDetailContentItemSingleCreatorProps'

const StyledItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${convertUnit(80)};
  min-height: ${convertUnit(80)};
  cursor: pointer;
`

const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${convertUnit(5)};
  max-width: ${convertUnit(400)};
  @media (max-width: ${WINDOW_MODE_MOBILE_WIDTH}px) {
    max-width: 100%;
  }
`

const StyledGridPhoto = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: ${convertUnit(15)};
`

const StyledItemEnd = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-self: start;
  gap: ${convertUnit(4)};
`

const StyledStrikeThroughParagraph = styled(Paragraph)`
  text-decoration: line-through;
`

const StyledOverflowParagraph = styled(Paragraph)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  overflow-wrap: anywhere;
`

const StyledImage = styled(Image)`
  width: ${convertUnit(64)};
  height: ${convertUnit(64)};
`

export default function TransactionDetailContentItemSingleCreator({
  content,
  showDiscount = false,
  showPackage = false,
  onClickItem,
}: TransactionDetailContentItemSingleCreatorProps) {
  const {
    content_type,
    url,
    type,
    title,
    price: afterDiscount,
    creator_price: beforeDiscount = 0,
    tags,
  } = content

  return (
    <StyledItemContainer onClick={onClickItem}>
      <StyledGridPhoto>
        {content_type === 'video' && (
          <GiftShopTemplateContentVideoBadge width={20} />
        )}
        <StyledImage
          useLazyLoad
          src={getContentURL({url, type})}
          alt={`content-item:${title}`}
          style={{borderRadius: convertUnit(8)}}
        />
      </StyledGridPhoto>
      <StyledItem>
        {showPackage && tags?.length ? (
          <StyledItemEnd>
            <Icon type="collection" color="primary_5" />
            <StyledOverflowParagraph
              fontSize="s"
              fontWeight="bold"
              color="primary_5">
              {tags[0].name}
            </StyledOverflowParagraph>
          </StyledItemEnd>
        ) : (
          <></>
        )}
        <StyledOverflowParagraph
          fontWeight="bold"
          color="black_1"
          fontSize="m"
          lineHeight={24}>
          {title}
        </StyledOverflowParagraph>
        <StyledItemEnd>
          {!showDiscount || afterDiscount === beforeDiscount ? (
            <Paragraph fontSize="s" color="primary_5">
              {getCurrencyValue(afterDiscount)}
            </Paragraph>
          ) : (
            <>
              <Paragraph fontSize="s" color="primary_5">
                {getCurrencyValue(afterDiscount)}
              </Paragraph>
              <StyledStrikeThroughParagraph fontSize="s" color="gray_3">
                {getCurrencyValue(beforeDiscount)}
              </StyledStrikeThroughParagraph>
            </>
          )}
        </StyledItemEnd>
      </StyledItem>
    </StyledItemContainer>
  )
}
